export const loaderSize = {
  small: { height: 24, width: 24 },
  medium: { height: 40, width: 40 },
  large: { height: 60, width: 60 },
};
